<template>
	<div class="qingwu">
		<div class="admin_main_block">
			<div class="admin_main_block_top">
				<div class="admin_main_block_left">
					<div>提现配置</div>
				</div>
				<div class="admin_main_block_right">
					<div><el-button icon="el-icon-back" @click="$router.go(-1)">返回</el-button></div>
				</div>
			</div>
			<div class="admin_form_main">
				<el-form label-width="100px" ref="info" :model="info" :rules="rules">
					<el-form-item label="提现金额" prop="price">
						<el-input type="number" placeholder="请输入提现金额" v-model="info.price"></el-input>
					</el-form-item>
					<el-form-item label="审核类型" prop="audit">
						<el-radio-group v-model="info.audit">
							<el-radio :label="1">免审核</el-radio>
							<el-radio :label="2">需审核</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="提现次数" prop="number">
						<el-input type="number" placeholder="请输入提现次数" v-model="info.number"></el-input>
					</el-form-item>
					<el-form-item label="模式" prop="mode">
						<el-radio-group v-model="info.mode">
							<el-radio :label="1">每天</el-radio>
							<el-radio :label="2">总数</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitForm('info')">提交</el-button>
						<el-button @click="resetForm('info')">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				edit_id: 0,
				info: {},
				rules: {
					price: [{
						required: true,
						message: "价格不能为空",
						trigger: "blur"
					}],
					audit: [{
						required: true,
						message: "请选择审核类型",
						trigger: "blur"
					}],
					number: [{
						required: true,
						message: "提现次数不能为空",
						trigger: "blur"
					}],
					mode: [{
						required: true,
						message: "请选择模式",
						trigger: "blur"
					}]
				}
			};
		},
		watch: {},
		computed: {},
		methods: {
			resetForm: function(e) {
				this.$refs[e].resetFields();
			},
			submitForm: function(e) {
				let _this = this;
				// 验证表单
				this.$refs[e].validate(function(res) {
					if (res) {
						//  判断是Add 或者 Edit
						let url = _this.$api.withdrawalAdd;
						if (_this.edit_id > 0) {
							url = _this.$api.withdrawalEdit+_this.edit_id;
						}

						// Http 请求
						_this.$post(url, _this.info).then(function(res) {
							if (res.code == 200) {
								_this.$message.success("编辑成功");
								_this.$router.go(-1);
							} else {
								_this.$message.error("编辑失败");
							}
						});
					}
				});
			},
		},
		created() {

			// 判断是否是编辑
			if (!this.$isEmpty(this.$route.params.id)) {
				this.edit_id = this.$route.params.id;
				this.info=this.$route.params
			}

		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>

</style>